import api from "@/lib/api";

// Every Approve / Reject button in the app goes through here.
//
// The dashboard used to build this request by hand and drifted out of step
// with the API - it sent {status, decision_note} when the endpoints want
// {decision, note} - so approving from the dashboard failed every time with
// "Field required". Keeping one definition is what stops that happening again.

const PATHS = {
  leave: (id) => `/leaves/${id}/decide`,
  regularization: (id) => `/attendance/regularize/${id}/decide`,
  approval: (id) => `/approvals/${id}/decide`,
};

export function decidePath(kind, id) {
  const make = PATHS[kind];
  if (!make) throw new Error(`Unknown approval kind: ${kind}`);
  return make(id);
}

export function decideBody(approve, note) {
  const body = { decision: approve ? "approved" : "rejected" };
  if (note) body.note = note;
  return body;
}

export function decideRequest(kind, id, approve, note = "") {
  return api.post(decidePath(kind, id), decideBody(approve, note));
}


// Both payroll pages report the outcome of a notice the same way, so the
// wording cannot drift between employees and contractors.
export function describeNotice(data, mode) {
  const n = data.sent || 0;
  const marked = data.marked || 0;
  const bits = [];
  if (mode === "paid" && marked) {
    bits.push(`${marked} marked paid`);
  }
  bits.push(n ? `${n} email${n === 1 ? "" : "s"} sent` : "no emails sent");
  const skipped = (data.skipped || []).length;
  if (skipped) bits.push(`${skipped} skipped`);
  return bits.join(", ");
}
